
import {postUpdateBalance} from '../api/postUpdateBalance';
import { setViewGroups } from './setGetViewGroup';

const setPostUpdateBalance = (params, setIsOpen) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateBalance(params);
            setIsOpen(true);
            dispatch(setViewGroups({
                id: params.id
            }))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateBalance
}